export enum Collections {
  Merchants = 'merchants'
}
